import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
    logoContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-around',
      maxHeight: '100',
      margin: "15px 0"
    },
    logo: {
      height: '75px',
      objectFit: 'contain',
      padding: "20px",
      boxSizing: "border-box"
    },
    logoText: {
      padding: "6px 0",
      color: '#000',
      fontSize: "2.125rem",
      fontWeight: '700',
      textAlign: 'center'
    }
  });

export default function Header() {
    const classes = useStyles();
    return (
        <div className={classes.logoContainer}>
            <Typography variant="h5" component="h5" className={classes.logoText}>
              Fixed Wireless Vs Cellular MiFi Cost Comparison
            </Typography>
        </div>
    )
}
